import { Controller } from "@hotwired/stimulus"
import { animate, utils } from "animejs"

// Анимирует дочерние карточки поочерёдно при появлении в DOM.
// Использование:
//   <div data-controller="stagger-cards">
//     <div>карточка 1</div>
//     <div>карточка 2</div>
//   </div>
//
// Опции (data-атрибуты контроллера):
//   data-stagger-cards-delay-value="80"      -- задержка между карточками, мс (default: 80)
//   data-stagger-cards-duration-value="500"  -- длительность одной анимации, мс (default: 500)

export default class extends Controller {
  static values = {
    delay:    { type: Number, default: 80 },
    duration: { type: Number, default: 500 },
  }

  connect() {
    const cards = Array.from(this.element.children)
    // Скрываем сразу, чтобы не было flash
    cards.forEach(card => { card.style.opacity = "0"; card.style.transform = "translateY(24px)" })

    animate(cards, {
      opacity:    [0, 1],
      translateY: [24, 0],
      easing:     "easeOutQuart",
      duration:   this.durationValue,
      delay:      utils.stagger(this.delayValue),
    })
  }
}
